import { z } from 'zod';
/** IDs are UUID v4 strings everywhere — API-CONTRACT.md §1. */
export const uuidSchema = z.uuid();
/** Cursor pagination only. Offset pagination is banned on customer lists. */
export const paginationSchema = z.object({
    cursor: z.string().optional(),
    limit: z.coerce.number().int().min(1).max(100).default(25),
});
/** Timestamps cross the wire as UTC ISO-8601 with a `Z`. */
export const isoDateTimeSchema = z.iso.datetime();
/**
 * `Brand.primaryColor`. Six-digit hex only — the shorthand form complicates the
 * contrast maths in DESIGN-SYSTEM.md §2 for no benefit.
 */
export const hexColorSchema = z
    .string()
    .regex(/^#[0-9A-Fa-f]{6}$/, 'Must be a 6-digit hex colour, for example #5B4BE8');
/** Money is always integer minor units plus a currency code. Never a float. */
export const moneySchema = z.object({
    amountCents: z.number().int(),
    currency: z.string().length(3).toUpperCase(),
});
export const localeSchema = z.enum(['en', 'ar']);
/**
 * A phone number as it arrives from a client. Normalisation to E.164 happens
 * server-side in the boundary pipe — a client-supplied E.164 string is an input,
 * never a trusted identity.
 */
export const rawPhoneSchema = z.string().min(4).max(32);
/** Idempotency keys are client-generated UUID v4 — API-CONTRACT.md §1. */
export const idempotencyKeySchema = z.uuid();
//# sourceMappingURL=common.js.map